import request from './interceptor'

export function getCleaningGroups(params = {}) {
  const defaults = { page: 1, page_size: 10 }
  const finalParams = { ...defaults, ...params }
  return request({ url: '/v1/box-groups', method: 'get', params: finalParams })
}

export function createCleaningGroup(data) {
  return request({ url: '/v1/box-groups', method: 'post', data })
}

export function updateCleaningGroup(id, data) {
  return request({ url: `/v1/box-groups/${id}`, method: 'post', data })
}

export function deleteCleaningGroup(id) {
  return request({ url: `/v1/box-groups/${id}`, method: 'get' })
}
